import { AllowedOperation, ClassName, Role } from '@sim/role/models/role';

export function getAllRoleClassNames(role: Role) {
  return role.capabilities.reduce(
    (all, current) => [...all, ...(current.classNames ? current.classNames : [])],
    [] as ClassName[],
  );
}

export function mapClassNameWithAllowedOperations(role: Role) {
  return role.capabilities.reduce((classNames, c) => {

    for (const cn of c.classNames || []) {
      if (classNames[cn]) {
        const currentAllowedOperations = (c.allowedOperations || []) as AllowedOperation;
        const allAllowedOperations = [...classNames[cn], ...currentAllowedOperations ];
        const distinctAllowedOperations = new Set(allAllowedOperations);
        classNames[cn] = [...distinctAllowedOperations] as AllowedOperation;
      } else {
        classNames[cn] = c.allowedOperations || [];
      }
    }
    return classNames;
  }, {} as Record<ClassName, AllowedOperation>);
}

export function isUserAdmin(role: Role) {
  return role.capabilities.some((c) => c.name === 'admin');
}

export function checkIsAllow(userRole: Role, allowedOperation: AllowedOperation = [], className?: ClassName) {
  if (isUserAdmin(userRole)) {
    return true;
  }
  if (!className) {
    return false;
  }
  if (allowedOperation.length === 0) {
    return false;
  }

  const mapClassName = mapClassNameWithAllowedOperations(userRole);

  let isUserAllow = false;
  if (mapClassName[className]) {
    const userAllowedOperation = mapClassName[className];

    allowedOperation.forEach((ao) => {
      if (userAllowedOperation.includes(ao)) {
        isUserAllow = true;
      }
    });
  }

  return isUserAllow;
}
